import moment from 'moment';
import { createI18N } from './i18n';

const I18N = createI18N({
  parsePage: true,
  namespace: `${window.mcmsWithoutAppName ? '' : 'intl-gangesweb.'}onepage.ma`
});
const MessengerI18N = createI18N({
  parsePage: true,
  namespace: `${window.mcmsWithoutAppName ? '' : 'intl-gangesweb.'}messenger.list`
});

const opToString = Object.prototype.toString;

const Utils = {
  /**将毫秒转换为YYYY-MM-DD:hh mm**/
  convertDate(value) {
    if (value) {
      const now = moment().format('YYYY-MM-DD HH:mm'),
        date = moment(value).format('YYYY-MM-DD HH:mm');

      if (now === date) {
        return moment(value).format('HH:mm');
      } else {
        return date;
      }
    } else {
      return '';
    }
  },

  decodeHTML(string) {
    if (!string) {
      return string;
    }

    string = string.replace(/&lt;|&#60;/g, '<');
    string = string.replace(/&gt;|&#62;/g, '>');
    string = string.replace(/&apos;|&#39;/g, '\'');
    string = string.replace(/&quot;|&#34;/g, '"');
    string = string.replace(/&amp;|&#38;/g, '&');

    return string;
  },
  // 能够反转义拉丁字符
  _decodeHtml(html) {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  },

  encodeHTML(string) {
    if (string.length === 0) {
      return '';
    }

    string = string.replace(/&/g, '&amp;');
    string = string.replace(/</g, '&lt;');
    string = string.replace(/>/g, '&gt;');
    string = string.replace(/'/g, '&#39;');
    string = string.replace(/"/g, '&quot;');

    return string;
  },

  getFileEtx(imageUrl, name) {
    let ext = '';
    if (name.lastIndexOf('.') !== -1 && name.lastIndexOf('.') !== name.length - 1) {
      ext = name.substring(name.lastIndexOf('.') + 1).toLowerCase();
    } else if (imageUrl.lastIndexOf('.') !== -1) {
      ext = imageUrl.substring(imageUrl.lastIndexOf('.') + 1, imageUrl.lastIndexOf('?'));
    } else {
      ext = 'attachment';
    }

    if (ext === 'xlsx') {
      ext = 'xls';
    }

    if (ext === 'docx') {
      ext = 'doc';
    }

    if (ext === 'jpg') {
      ext = 'jpeg';
    }

    // 如果ext不在默认里面，使用默认
    const defaultExt = { xls: true, xlsx: true, txt: true, rar: true, zip: true, pdf: true, doc: true, docx: true, gif: true, jpg: true, jpeg: true, bmp: true, tif: true, png: true };
    if (!defaultExt[ext]) {
      ext = 'attachment';
    }

    return ext;
  },

  prefixString(prefix = '') {
    const buffers = {};

    return (content) => {
      if (content === undefined || content === null) {
        return (prefix + content);
      }

      let finalContent = buffers[content];

      if (finalContent === undefined) {
        finalContent = prefix + content;
        buffers[content] = finalContent;
      }

      return finalContent;
    };
  },

  formatNumber(num) {
    return (num < 10) ?
      (`0${num}`) :
      num;
  },

  timeSince(date) {
    if (typeof date !== 'object') {
      date = new Date(date);
    }

    let seconds = Math.floor((new Date() - date) / 1000);
    const dateStr = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

    if (seconds > 60 * 60 * 24) {
      return dateStr;
    }

    const d = new Date();
    const diff = (d.getTime() - new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime()) / 1000;

    seconds = seconds - diff;

    const interval = Math.ceil(seconds / 86400);
    const hour = Utils.formatNumber(date.getHours());
    const minute = Utils.formatNumber(date.getMinutes());
    const tt = `${hour}:${minute}`;

    return (interval === 1) ?
      dateStr :
      (`${tt}`);
  },

  mergeObjects(...args) {
    return args.reduce((newObject, arg) => ({
      ...newObject,
      ...arg
    }), {});
  },

  isString(obj) {
    return typeof obj === 'string';
  },

  isFunction(fn) {
    return typeof fn === 'function';
  },

  isArray(obj) {
    return opToString.call(obj) === '[object Array]';
  },

  parseArray(obj = []) {
    return Utils.isArray(obj) ? obj : [obj];
  },

  arrayIncludes(arr, searchElement) {
    if (!arr) {
      return false;
    }

    return arr.indexOf(searchElement) !== -1;
  },

  getI18NEntryValue(key, prefix) {
    return prefix ?
      I18N.get(`${prefix}.${key}`) :
      I18N.get(key);
  },

  newGetI18NEntryValueWithPrefix(prefix) {
    return (key) => Utils.getI18NEntryValue(key, prefix);
  },

  htmlDecode(input) {
    const $element = document.createElement('div');
    $element.innerHTML = input;

    return $element.childNodes.length === 0 ? '' : $element.childNodes[0].nodeValue;
  },

  getParamsFromUrl() {
    const search = window.location.search.slice(1);
    const items = search.split('&');

    for (let i = 0; i < items.length; i++) {
      const item = items[i].split('=');
      if (item[0] === 'urlParams') {
        return JSON.parse(decodeURIComponent(item[1]));
      }
    }
    return {};
  },

  getUrlVars() {
    let vars = {};
    // @ts-ignore
    window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {  // eslint-disable-line
      vars[key] = value;
    });
    return vars;
  },

  getLinkVars(link) {
    let vars = {};
    // @ts-ignore
    link.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {  // eslint-disable-line
      vars[key] = value;
    });
    return vars;
  },

  // 保持登录态session
  heartbeat() {
    let relayScriptEl = null, minutes = 5;
    const relay = () => {
      relayScriptEl.src = `//login.alibaba.com/xlogin/relay.htm?_=${Date.now()}`;
    }
    relayScriptEl = document.createElement('script');
    relayScriptEl.type = 'text/javascript';
    document.head.appendChild(relayScriptEl);
    setInterval(relay, minutes * 60 * 1000);
  },

  formatMsgType(content = '', imMessageType, extraContent = '') {
    content = this.decodeHTML(content);
    switch (imMessageType) {
      case 1:
        if (content.match('<img src=')) {
          return `[${MessengerI18N.get('content.image') || 'Image'}${extraContent}]`;
        }
        return content;
      case 2:
        return `[${MessengerI18N.get('content.image') || 'Image'}${extraContent}]`;
      case 3:
        return `[${MessengerI18N.get('content.file') || 'File'}${extraContent}]`;
      case 4:
        return `[${MessengerI18N.get('content.audio') || 'Audio'}${extraContent}]`;
      case 5:
        return `[${MessengerI18N.get('content.video') || 'Video'}${extraContent}]`;
      case 50:
        return `[${MessengerI18N.get('content.inquiry') || 'Inquiry'}${extraContent}]`;
      case 52:
        return `[${MessengerI18N.get('content.quotation') || 'Quotation'}${extraContent}]`;
      case 53:
        return `[${MessengerI18N.get('content.file') || 'File'}${extraContent}]`;
      case 54:
        return `[${MessengerI18N.get('content.product') || 'Product'}${extraContent}]`;
      case 55:
        return `[${MessengerI18N.get('content.company') || 'Company'}${extraContent}]`;
      case 56:
        return `[${MessengerI18N.get('content.behavior') || 'Behavior'}${extraContent}]`;
      case 57:
        return `[${MessengerI18N.get('content.businessCard') || 'Business card'}${extraContent}]`;
      case 58:
        return `[${MessengerI18N.get('content.ta') || 'TA'}${extraContent}]`;
      case 59:
        return `[${MessengerI18N.get('content.tradeAssurance') || 'Trade Assurance'}${extraContent}]`;
      case 60:
        return `[${MessengerI18N.get('content.image') || 'Image'}${extraContent}]`;
      case 61:
        return `[${MessengerI18N.get('content.file') || 'File'}${extraContent}]`;
      case 62:
        return `[${MessengerI18N.get('content.video') || 'Video'}${extraContent}]`;
      case 63:
        return `[${MessengerI18N.get('content.text') || 'Text'}${extraContent}]`;
      case 64:
        return `[${MessengerI18N.get('content.orderTracking') || 'Order Tracking'}${extraContent}]`;
      case 65:
        return `[${MessengerI18N.get('content.businessCard') || 'Business card'}${extraContent}]`;
      case 66:
        return `[${MessengerI18N.get('content.businessCard') || 'Business card'}${extraContent}]`;
      case 2000:
        return `[${MessengerI18N.get('content.product') || 'Products'}${extraContent}]`;
      case 2001:
        return `[${MessengerI18N.get('content.quotation') || 'Quotation'}${extraContent}]`;
      case 2002:
        return `[${MessengerI18N.get('content.ta') || 'Order'}${extraContent}]`;
      default:
        return `[${MessengerI18N.get('content.message') || 'Message'}${extraContent}]`;
    }
  },

  getUserInfo() {
    const matchResult = /xman_us_f=*.+?(x_user=*.+?)[&;]/.exec(document.cookie);
    const loginIdMatched = /x_lid=(.+?)[&;]/.exec(document.cookie);
    const loginId = loginIdMatched && loginIdMatched[loginIdMatched.length - 1] || '';

    const xUser = (matchResult && matchResult[1] && matchResult[1].slice(7)) || '';
    const items = (xUser && xUser.split('|')) || [];
    const currentAccountId = items[items.length - 1];

    return {
      accountId: currentAccountId,
      loginId: loginId,
    };
  },

  getBrowser() {
    const UserAgent = navigator.userAgent.toLowerCase();
    const browserInfo = {};
    const browserArray = {
      IE: window.ActiveXObject || "ActiveXObject" in window, // IE
      Chrome: UserAgent.indexOf('chrome') > -1 && UserAgent.indexOf('safari') > -1, // Chrome浏览器
      Firefox: UserAgent.indexOf('firefox') > -1, // 火狐浏览器
      Opera: UserAgent.indexOf('opera') > -1, // Opera浏览器
      Safari: UserAgent.indexOf('safari') > -1 && UserAgent.indexOf('chrome') == -1, // safari浏览器
      Edge: UserAgent.indexOf('edge') > -1, // Edge浏览器
      QQBrowser: /qqbrowser/.test(UserAgent), // qq浏览器
      WeixinBrowser: /MicroMessenger/i.test(UserAgent) // 微信浏览器
    };
    // console.log(browserArray)
    for (const i in browserArray) {
      if (browserArray[i]) {
        let versions = '';
        if (i == 'IE') {
          versions = UserAgent.match(/(msie\s|trident.*rv:)([\w.]+)/)[2];
        } else if (i == 'Chrome') {
          for (const mt in navigator.mimeTypes) {
            //检测是否是360浏览器(测试只有pc端的360才起作用)
            if (navigator.mimeTypes[mt]['type'] == 'application/360softmgrplugin') {
              i = '360';
            }
          }
          versions = UserAgent.match(/chrome\/([\d.]+)/)[1];
        } else if (i == 'Firefox') {
          versions = UserAgent.match(/firefox\/([\d.]+)/)[1];
        } else if (i == 'Opera') {
          versions = UserAgent.match(/opera\/([\d.]+)/)[1];
        } else if (i == 'Safari') {
          versions = UserAgent.match(/version\/([\d.]+)/)[1];
        } else if (i == 'Edge') {
          versions = UserAgent.match(/edge\/([\d.]+)/)[1];
        } else if (i == 'QQBrowser') {
          versions = UserAgent.match(/qqbrowser\/([\d.]+)/)[1];
        }
        browserInfo.type = i;
        browserInfo.versions = parseInt(versions);
      }
    }
    return browserInfo;
  },

  getAccountId() {
    return (window.GDATA && window.GDATA.user && window.GDATA.user.memberId) || window.currentUserAccountId;
  }
};

export default Utils;
